import store from '@/store'
export default {
  setMapCenterBaseOnCountryId() {
    const countryId = localStorage.getItem('country_id')
    const map = this.getMap()
    let geocoder
    if (countryId !== null) {
      switch (countryId) {
        case 'ar':
          geocoder = new google.maps.Geocoder()
          geocoder.geocode({ address: 'Argentina' }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              map.setCenter(results[0].geometry.location)
              map.fitBounds(results[0].geometry.viewport)
            }
          })
          break
        case 'cl':
          geocoder = new google.maps.Geocoder()
          geocoder.geocode({ address: 'Chile' }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              map.setCenter(results[0].geometry.location)
              map.fitBounds(results[0].geometry.viewport)
            }
          })
          break
        case 'uy':
          geocoder = new google.maps.Geocoder()
          geocoder.geocode({ address: 'Uruguay' }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              map.setCenter(results[0].geometry.location)
              map.fitBounds(results[0].geometry.viewport)
            }
          })
          break
        default:
          geocoder = new google.maps.Geocoder()
          geocoder.geocode({ address: 'Argentina' }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              map.setCenter(results[0].geometry.location)
              map.fitBounds(results[0].geometry.viewport)
            }
          })
          break
      }
    }
  },
  getMap() {
    return store.getters['mapState/map']
  }
}
